// src/school/pages/AddStudent.jsx

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./addStudent.css";

export default function AddStudent() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  const [photo, setPhoto] = useState(null);
  const [preview, setPreview] = useState(null);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    name: "",
    student_id: "",
    student_password: "",
    parent_id: "",
    parent_password: "",
    class_model: "",
    section: "",
    roll_number: "",
    gender: "",
    dob: "",
    religion: "", // ✅ NEW
    emis_number: "", // ✅ NEW
    parent_name: "",
    parent_phone: "",
    address: "",
    blood_group: "",
    father_name: "",
    mother_name: "",
    guardian_name: "",

    parent_email: "",
    parent_qualification: "",
    parent_income: "",

    aadhaar_number: "",
    notes: "",
  });

  // Load Classes
  const loadClasses = async () => {
    const res = await API.get("/school-admin/classes/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setClasses(res.data.classes);
  };

  // Load sections based on class
  const loadSections = async (classId) => {
    if (!classId) return;
    const res = await API.get(`/school-admin/sections/${classId}/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setSections(res.data.sections);
  };

  useEffect(() => {
    loadClasses();
  }, []);

  // Handle form changes
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });

    if (e.target.name === "class_model") {
      loadSections(e.target.value);
    }
  };

  // Handle image drag/drop
  const handlePhoto = (file) => {
    setPhoto(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) handlePhoto(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) handlePhoto(file);
  };

  const handleDragOver = (e) => e.preventDefault();

  // Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    const fd = new FormData();

    Object.keys(form).forEach((key) => {
      fd.append(key, form[key]);
    });

    if (photo) fd.append("photo", photo);

    try {
      await API.post("/school-admin/students/add/", fd, {
        headers: {
          "X-SCHOOL-ID": school.school.id,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Student added successfully!");
      navigate("/school-admin/students");
    } catch (err) {
      console.log(err);
      alert("Error adding student");
    } finally {
      setSaving(false);
    }
  };

  return (

      <div className="add-student-page">
        <div className="add-student-hero">
          <div className="add-student-hero-left">
            <span className="add-student-hero-icon">🎓</span>
            <div>
              <h1>Add Student</h1>
              <p>Create student login, class details, parent profile, and records</p>
            </div>
          </div>

          <button
            type="button"
            className="add-student-back"
            onClick={() => navigate("/school-admin/students")}
          >
            Student List
          </button>
        </div>

      <div className="add-student-container">

        <form onSubmit={handleSubmit} className="add-student-form">
          {/* PHOTO UPLOAD */}
          <div className="add-student-grid">
            <aside className="add-student-photo-panel">
              <p className="add-student-panel-label">Student Photo</p>
              <div
                className="photo-upload-box"
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                {preview ? (
                  <img src={preview} alt="Preview" className="preview-image" />
                ) : (
                  <div className="upload-text">
                    <span>Drop photo here</span>
                    <label className="upload-btn">
                      Choose File
                      <input type="file" hidden onChange={handleFileSelect} />
                    </label>
                  </div>
                )}
              </div>
              <p className="add-student-photo-note">
                Square portraits work best for student cards and profile pages.
              </p>
            </aside>

            <div className="add-student-fields">
              <h4 className="section-title">Student Login</h4>
              <div className="add-student-section-card">
          
          {/* NAME */}
          <div className="form-group">
            <label>Student Name</label>
            <input type="text" name="name" onChange={handleChange} required />
          </div>


          {/* ID & PASSWORD */}
          <div className="form-row">
            <div className="form-group">
              <label>Student ID</label>
              <input
                type="text"
                name="student_id"
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="text"
                name="student_password"
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>Religion</label>
            <input type="text" name="religion" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>EMIS Number</label>
            <input type="text" name="emis_number" onChange={handleChange} />
          </div>
          </div>
          {/* CLASS & SECTION */}
          <h4 className="section-title">Academic Details</h4>
          <div className="add-student-section-card">
          <div className="form-row">
            <div className="form-group">
              <label>Class</label>
              <select name="class_model" onChange={handleChange} required>
                <option value="">Select Class</option>
                {classes.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Section</label>
              <select name="section" onChange={handleChange} required>
                <option value="">Select Section</option>
                {sections.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* OTHER DETAILS */}
          <div className="form-group">
            <label>Roll Number</label>
            <input type="text" name="roll_number" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Gender</label>
            <select name="gender" onChange={handleChange}>
              <option value="">Select Gender</option>
              <option>Male</option>
              <option>Female</option>
            </select>
          </div>

          <div className="form-group">
            <label>Date of Birth</label>
            <input type="date" name="dob" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Blood Group</label>
            <input type="text" name="blood_group" onChange={handleChange} />
          </div>
          </div>

          {/* ================= PARENT LOGIN (ADD-ON) ================= */}
          <h4 className="section-title">Parent Login Details</h4>
          <div className="add-student-section-card">
          <div className="form-group">
            <label>Parent Name</label>
            <input type="text" name="parent_name" onChange={handleChange} />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Parent Login ID</label>
              <input
                type="text"
                name="parent_id"
                onChange={handleChange}
                placeholder="e.g. parent_101"
                required
              />
            </div>

            <div className="form-group">
              <label>Parent Password</label>
              <input
                type="text"
                name="parent_password"
                onChange={handleChange}
                placeholder="Parent password"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>Parent Phone</label>
            <input type="text" name="parent_phone" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Address</label>
            <textarea name="address" onChange={handleChange}></textarea>
          </div>
          </div>
          {/* ================= EXTRA PARENT DETAILS ================= */}
          <h4 className="section-title">Additional Parent Details</h4>
          <div className="add-student-section-card">

          <div className="form-group">
            <label>Father Name</label>
            <input type="text" name="father_name" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Mother Name</label>
            <input type="text" name="mother_name" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Guardian Name</label>
            <input type="text" name="guardian_name" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Parent Email</label>
            <input type="email" name="parent_email" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Parent Qualification</label>
            <input
              type="text"
              name="parent_qualification"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Parent Income</label>
            <input type="number" name="parent_income" onChange={handleChange} />
          </div>
          </div>

          {/* ================= STUDENT EXTRA DETAILS ================= */}
          <h4 className="section-title">Additional Student Details</h4>
          <div className="add-student-section-card">

          <div className="form-group">
            <label>Student Aadhaar Number</label>
            <input type="text" name="aadhaar_number" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Notes</label>
            <textarea name="notes" onChange={handleChange} rows="4"></textarea>
          </div>
          </div>

          <button className="btn-submit" disabled={saving}>
            {saving ? "Adding Student..." : "Add Student"}
          </button>
            </div>
          </div>
        </form>
      </div>
      </div>

  );
}
